import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { Typography } from '@material-ui/core'

import noResultsFound from '../../../assets/images/noResultFound.svg'
import { getTranslate } from '../../../localization'
import { CheckStatus } from '../../../types/checkStatus'
import CheckStatusRowSkeleton from './CheckStatusRowSkeleton.skeleton'
import CheckStatusTableHeader from './CheckStatusTableHeader'
import CheckStatusTableRow from './CheckStatusTableRow'
import useStyles from './styles/CheckStatusTable.styles'

interface CheckStatusTableProps {
  data: CheckStatus | undefined
  loading: boolean
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      checkStatus: CheckStatus
    }>
  >
}

const CheckStatusTable: React.FC<CheckStatusTableProps> = ({
  data,
  loading,
  refetch
}) => {
  const classes = useStyles()

  return (
    <div>
      <CheckStatusTableHeader refetch={refetch} />
      {loading ? (
        Array(5)
          .fill(null)
          .map((_, index) => <CheckStatusRowSkeleton key={index} />)
      ) : data && data.rooms && data.rooms.length > 0 ? (
        data.rooms.map((room, index) => (
          <CheckStatusTableRow key={index} data={room} />
        ))
      ) : (
        <div className={classes.noResultFound}>
          <img
            src={noResultsFound}
            className={classes.noresult}
            alt="No results"
          />
          <Typography variant="h2" className={classes.noResults}>
            {getTranslate('No result Found')}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default CheckStatusTable
